<div [ngClass]="{'row':true, 'row_main': true}">
  @if(step == 1){
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn">

      <div style="margin-top: 30px;">
        <div class="stepper">
          <div [ngClass]="{'step': true, 'active': stepper_aval == 1 || stepper_aval == 3}">
            <div class="circle">
              1
            </div>
            <div class="step-text">datos aval</div>
          </div>
          <div class="line"></div>
          <div [ngClass]="{'step': true, 'active': stepper_aval == 2}">
            <div class="circle">
              2
            </div>
            <div class="step-text">datos firmantes</div>
          </div>
          <div class="line"></div>
          <div [ngClass]="{'step': true, 'active': stepper_aval == 4}">
            <div class="circle">
              3
            </div>
            <div class="step-text">cuenta bancaria</div>
          </div>

        </div>
        <div class="titulo" style="margin-bottom: 10px;">
          @if(stepper_aval == 1) {
            confirma los datos de la persona que asumirá el rol de aval de la empresa
          }
          @if(stepper_aval == 2) {
            ingresa los datos de las personas que deben firmar el contrato
          }
          @if(stepper_aval == 3) {
            un ejecutivo te contactará para gestionar el cambio de aval
          }
          @if(stepper_aval == 4) {
            agrega la cuenta bancaria de tu empresa
          }
        </div>

      </div>

      <mat-card class="centerabsolute margin-mobile" style="max-width: 800px;">

        @if(stepper_aval == 1) {
          <mat-card-content>
            <div class="mat-container">

              <div class="box-info">
                @if (avales.length === 1) {
                  <div>La persona con mayor <strong>participación y/o responsabilidad legal en la
                  empresa</strong> deberá
                  asumir el rol de aval. Confirma sus datos para que pueda recibir y <strong>firmar el contrato</strong>.
                </div>
              }

              @if (avales.length > 1) {
                <div>Las personas con mayor <strong>participación y/o responsabilidad legal en la
                empresa</strong> deberán actuar como avales. Confirma sus datos para que puedan recibir y <strong>firmar
              el contrato</strong>.
            </div>
          }
        </div>

        @for (aval of avales; track aval; let i = $index) {
          <div>
            <mat-card appearance="outlined" class="avales-card">
              <mat-card-content class="aval-container">
                <div class="name">
                  {{aval.nombre}} {{aval.apellidos}}
                </div>
                <div class="contacto">
                  <div class="phone">
                    Teléfono:
                    <span class="edit-contact">
                      <input class="edit-contact no-input" type="number" value="{{aval.telefono}}" readonly>
                      <span class="material-symbols-outlined" (click)="editPhone()">edit</span>
                    </span>
                  </div>
                  <div class="mail">
                    Correo:
                    <span class="edit-contact">
                      <input class="edit-contact no-input" type="email" value="{{aval.email}}" readonly>
                      <span class="material-symbols-outlined" (click)="editEmail()">edit</span>
                    </span>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        }


        <div class="caja-botones">
          <button mat-stroked-button class="primary-button" (click)="coninuar_stepper2()">Confirmar datos</button>
        </div>

        <div class="footer-botones">
          <span (click)="open_modal_info(27)">Prefiero agregar a otra persona o empresa como aval</span>
        </div>

      </div>
    </mat-card-content>
  }

  @if(stepper_aval == 2) {
    <mat-card-content>
      <div class="mat-container">

        <div class="box-info">
          <div>Necesitamos los datos de las personas que actúan como <strong>representantes y/o apoderadas legales</strong> de la empresa para enviarles el contrato y la <span (click)="open_modal_info(32)">documentación que deben firmar.</span></div>
        </div>

        <mat-card appearance="outlined" class="avales-card">
          <mat-card-content>
            @for (firmante of firmantes; track firmante; let i = $index; let last = $last) {
              <div class="aval-container"
                [ngClass]="{'with-border': !last}">
                <div class="name">
                  <strong>{{firmante.nombre}} {{firmante.apellido}}</strong>
                  @if (firmante.rol === 'conyuge') {
                    <div class="conyuge">
                      Cónyuge de {{nombreCompletoTitular}}
                    </div>
                  }
                  @if (firmante.rol === 'conyuge') {
                    <div class="conyuge-span">
                      <span class="material-symbols-outlined">error</span> <span (click)="open_modal_info(30)">¿Por qué es
                    necesaria esta firma?</span>
                  </div>
                }
              </div>
              @if (!firmante.telefono && !firmante.email) {
                <div class="contacto">
                  <button mat-stroked-button class="primary-button" (click)="ingresar_datos(firmante.id)">
                    <span class="material-symbols-outlined">assignment</span> Ingresar datos
                  </button>
                </div>
              }
              @if (firmante.telefono || firmante.email) {
                <div class="contacto">
                  <div class="phone">
                    Teléfono:
                    <span class="edit-contact">
                      <input class="edit-contact no-input" type="number" [value]="firmante.telefono" readonly>
                      <span class="material-symbols-outlined" (click)="ingresar_datos(firmante.id)">edit</span>
                    </span>
                  </div>
                  <div class="mail">
                    Correo:
                    <span class="edit-contact">
                      <input class="edit-contact no-input" type="email" [value]="firmante.email" readonly>
                      <span class="material-symbols-outlined" (click)="ingresar_datos(firmante.id)">edit</span>
                    </span>
                  </div>
                </div>
              }
            </div>
          }
        </mat-card-content>
      </mat-card>


      <div class="caja-botones" style="margin-top: 30px;">
        <!-- <button mat-stroked-button class="primary-button" (click)="step = 2; put_step(10)">Finalizar</button> -->
        <button mat-stroked-button class="primary-button" (click)="stepper_aval = 4">Continuar</button>
      </div>

    </div>
  </mat-card-content>
}

@if(stepper_aval == 3) {
  <mat-card-content>
    <div class="mat-container">

      <div class="imagen-final">
        <img src="../../assets/iconografia/Iconografia - calendar.png" style="height: 160px !important;">
      </div>

      <div class="subtitulo-card">
        <strong>Continúa hacia el paso 2</strong> mientras avanzamos con tu solicitud.
      </div>

      <div class="caja-botones" style="margin-top: 30px;">
        <button mat-stroked-button class="primary-button" (click)="coninuar_stepper2()">Continuar</button>
        <button mat-stroked-button class="secondary-button" (click)="stepper_aval = 1">Volver atrás</button>
      </div>


    </div>
  </mat-card-content>
}

@if(stepper_aval == 4) {
  <mat-card-content>
    <div class="mat-container">

      <div class="box-info">
        <div>Necesitamos que realices este paso para crear el <span (click)="open_modal_info(33)">set legal de Poderes Bancarios</span> y gestionar el giro de tu financiamiento.</div>
      </div>


      <div class="caja-botones" style="margin-top: 30px;">
        <button mat-stroked-button class="secondary-button" (click)="stepper_aval = 2">Volver</button>
      </div>


    </div>
  </mat-card-content>
}

</mat-card>

</div>
}

@if (step == 2) {
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__faster animate__fadeIn step2-container">

    <div class="margin-step2">
      <mat-card class="centerabsolute2" style="max-width: 800px;">
        <mat-card-content>

          <div class="mat-container">
            <div class="icon">
              <span class="material-symbols-outlined">error</span>
            </div>

            <div class="titulo-card">
              nuestra área legal está terminando de generar el contrato
            </div>

            <div class="subtitulo-card">
              Te notificaremos cuando esté todo preparado para iniciar el proceso de firma electrónica.
            </div>

            <div class="caja-botones" style="margin-top: 30px;">
              <button mat-stroked-button class="secondary-button" (click)="logout()">Cerrar sesión</button>
            </div>

          </div>

        </mat-card-content>
      </mat-card>
    </div>
    <div class="contact-container">
      <contact-container></contact-container>
    </div>
  </div>
}


</div>